// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

if('NodeList' in window && !NodeList.prototype.forEach){
        NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
  }

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App :demo="demo"/>',
  data(){
    return {
      demo: "NONE"
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js